/* eslint-disable no-console */
import { csrfToken } from '../common/apiRoutes';

export const MESSAGES_PATH = '/ai/chatkit_v2/ruby_llm/messages';

export async function sendMessage({ chatId, content }) {
  const response = await fetch(MESSAGES_PATH, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken(),
      Accept: 'text/vnd.turbo-stream.html'
    },
    body: JSON.stringify({
      ai_chat_id: chatId,
      ai_message: { content }
    })
  });

  if (!response.ok) {
    console.error('[chatkit-v2] sendMessage failed', response.status, await response.text());
  }
}
